import React, { useState, useEffect } from 'react';
import { LOCALE_EN, LOCALE_RU } from '../constant';
import { WarningIcon } from '../appearence/icons/warning_icon';
import { useTranslation } from 'react-i18next';
import { Tooltip } from './Tooltip';
import {IconWrapper} from "../appearence/icons/icon_wrapper";

const checkIconVisibility = (itemCode, itemService, i18n) => {
    return itemService.getLocalization(LOCALE_EN, itemCode, false, i18n) === ''
        || itemService.getLocalization(LOCALE_RU, itemCode, false, i18n) === '';
};

const ListItemWarningIcon = ({ itemCode, itemService }) => {
    const { i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(checkIconVisibility(itemCode, itemService, i18n));
    }, [itemCode, itemService, i18n]);

    if (!isVisible) {
        return null;
    }

    return (
        <Tooltip content={i18n.t('app.page.product.warningLocaleHint')} placement="bottom-end">
            <div className="item__hint-warning" key={itemCode + 'warning'}>
                <IconWrapper><WarningIcon nameOfClass={`icon_warning`} /></IconWrapper>
            </div>
        </Tooltip>
    );
};

export default ListItemWarningIcon;
